/* eslint-disable */
(function ($) {
  Drupal.behaviors.chapterOption = {
    attach: function (context) {
      // Add prefix string to Chapters option values
      const myArr = document.querySelectorAll('.block--parent-chapter-number option');
      for (let i = 1; i < myArr.length; i++) {
        if (Number.isInteger(parseInt(myArr[i].textContent.trim()))) {
          myArr[i].textContent = 'Chapter' + myArr[i].textContent;
        }
      }
    }
  };
})(jQuery, Drupal);
